import "core-js/modules/es.number.constructor.js";
export default {
  props: {
    value: {
      default: 0,
      type: Number
    },
    min: {
      default: 0,
      type: Number
    },
    max: {
      default: undefined,
      type: Number
    }
  },
  data: function data() {
    return {
      newValue: 0
    };
  },
  methods: {
    getNotificationClass: function getNotificationClass(notification) {
      return "alert alert-".concat(notification.type);
    },
    mpplus: function mpplus() {
      if (this.max === undefined || this.newValue < this.max) {
        this.newValue = +this.newValue + 1;
        this.$emit("input", this.newValue);
      }
    },
    mpminus: function mpminus() {
      if (this.newValue > this.min) {
        this.newValue = +this.newValue - 1;
        this.$emit("input", this.newValue);
      }
    },
    mpm: function mpm(value) {
      this.newValue = +value;
      this.$emit("input", this.newValue);
    }
  },
  watch: {
    value: {
      handler: function handler(newVal, oldVal) {
        this.newValue = newVal;
      }
    }
  },
  created: function created() {
    this.newValue = this.value;
  }
};